const handler = ( $ ) => {

	$('.easygf-tooltip').append('<span class="gfield_tooltip"></span>');

	if( gform !== undefined ) {

		// register form: change page content on form step
		$(document).on( 'gform_page_loaded', function(event, form_id, current_page){
			
			if( form_id == '5') {

				if( $(`.form-steps-content.step-${current_page}`).length ) {
					$('.form-steps-content').hide();
					$(`.form-steps-content.step-${current_page}`).fadeIn();
				}

			}

		});

		// allow max 4 interests
		const setCheckboxesInterests = function( parentField = '' ) {

			if( parentField == '' ) {
				$('.checkboxes-grid').each( function() {

					const $parentBlock = $(this);

					if( $parentBlock.find(`input[type=checkbox]:checked`).length >= 3 ) {
						$parentBlock.find(`input[type=checkbox]`).not(':checked').attr('disabled', 'disabled' );
					} else {
						$parentBlock.find(`input[type=checkbox]`).removeAttr('disabled');
					}

				});
			} else {

				if( $(`${parentField} input[type=checkbox]:checked`).length >= 3 ) {
					$(`${parentField} input[type=checkbox]`).not(':checked').attr('disabled', 'disabled' );
				} else {
					$(`${parentField} input[type=checkbox]`).removeAttr('disabled');
				}

			}

		}

		// register form: allow max 3 interests
		gform.addAction( 'gform_input_change', (elem, formId, fieldId) => {

			const fieldID = fieldId.split('.')[0];

			if( 
				(formId == '5' && fieldID == '12') 
				|| (formId == '6' && fieldID == '24') 
				|| (formId == '6' && fieldID == '43') 
			) {

				setCheckboxesInterests( '#field_' + formId + '_' + fieldID);

			}

		});

		// Edit profile form: check count on form load
		if( $('#gform_6').length ) {
			setCheckboxesInterests();
			$('#input_6_16').attr('disabled', 'disabled').attr('readonly', 'readonly');
		}

		// Registration form: pre-fill username field based on email address
		if( $('#gform_5').length ) {

			$(document).on('gform_page_loaded', function(event, form_id, current_page){

				if( form_id == '5' ) {

					if( current_page == '3' ) {
						$('#input_5_22').attr( 'value', $('#input_5_9').val() ).attr('disabled', 'disabled').attr('readonly', 'readonly');

						$('#choice_5_14_1, #choice_5_15_1').attr('checked', 'checked');
					} 

				}

			});

		}

	}

};

export default ( ( $ ) => $( handler ) )( jQuery );
